import EnhancedContentRecord from "models/view-models/enhanced-content-record";
import React, {
    Dispatch,
    PropsWithChildren,
    SetStateAction,
    createContext,
    useContext,
    useState,
} from "react";

// -------------------------------------------------------------------------------------------------
// #region Types
// -------------------------------------------------------------------------------------------------

export type EnhancedContentUpdater = Dispatch<
    SetStateAction<EnhancedContentRecord[]>
>;

// #endregion Types

// -------------------------------------------------------------------------------------------------
// #region Context
// -------------------------------------------------------------------------------------------------

export const defaultState: EnhancedContentRecord[] = [];
const defaultUpdater: EnhancedContentUpdater = () => {};

export const CodeReferenceBlockEnhancedContentContext = createContext<
    [EnhancedContentRecord[], EnhancedContentUpdater]
>([defaultState, defaultUpdater]);

// #endregion Context

// -------------------------------------------------------------------------------------------------
// #region Provider
// -------------------------------------------------------------------------------------------------

const CodeReferenceBlockEnhancedContentContextProvider = (
    props: PropsWithChildren<{}>
) => {
    const [enhancedContent, setEnhancedContent] =
        useState<EnhancedContentRecord[]>(defaultState);

    return (
        <CodeReferenceBlockEnhancedContentContext.Provider
            value={[enhancedContent, setEnhancedContent]}>
            {props.children}
        </CodeReferenceBlockEnhancedContentContext.Provider>
    );
};

// #endregion Provider

// -------------------------------------------------------------------------------------------------
// #region Hook
// -------------------------------------------------------------------------------------------------

export const useCodeReferenceBlockEnhancedContentContext = () => {
    const [enhancedContent, setEnhancedContent] = useContext(
        CodeReferenceBlockEnhancedContentContext
    );

    return {
        enhancedContent,
        setEnhancedContent,
    };
};

// #endregion Hook

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export default CodeReferenceBlockEnhancedContentContextProvider;

// #endregion Exports
